import React from 'react'

const ArrowIcon = (props) =>(
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12"><path d="M11.9 10.206a.775.775 0 0 0-.682-.421h-4.431v-8.944a.789.789 0 1 0-1.574 0v8.944h-4.433a.775.775 0 0 0-.682.421c-.131.252-.131-.411 0-.159l5.22 7.533a.763.763 0 0 0 1.364 0l5.22-7.533c.131-.253.131.411-.002.159zm-5.9 5.294l-3.856-5.033h7.686z" transform="translate(0 12) rotate(-90)" fill={props.fill} /></svg>
)

export default ArrowIcon